import { SSOAccessTicket, SSOConnection } from "@cohesive/api-client";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { orgAPI } from "./api";

// Re-export the types
export type { SSOAccessTicket, SSOConnection };

// React Query hooks
export function useSSOConnections(
  options?: UseQueryOptions<SSOConnection[], AxiosError>,
) {
  return useQuery<SSOConnection[], AxiosError>({
    queryKey: ["sso-connections"],
    queryFn: () => orgAPI.organization.listSSOConnections(),
    ...options,
  });
}

export function useGenerateAccessTicket(
  options?: UseMutationOptions<SSOAccessTicket, AxiosError, string | undefined>,
) {
  return useMutation<SSOAccessTicket, AxiosError, string | undefined>({
    mutationFn: (connectionId) =>
      orgAPI.organization.generateAccessTicket(
        connectionId ? { connection_id: connectionId } : undefined,
      ),
    ...options,
  });
}
